var map = {
	"./skin1/edit_color_highlight@3x.png": "3de0",
	"./skin2/edit_color_highlight@3x.png": "3b22",
	"./skin3/edit_color_highlight@3x.png": "acbb",
	"./skin4/edit_color_highlight@3x.png": "e810",
	"./skin5/edit_color_highlight@3x.png": "0412",
	"./skin6/edit_color_highlight@3x.png": "a58a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a9b8";